export default {"src":"/_next/static/media/juggle.mono.ad4fe679.svg","height":364,"width":364,"blurWidth":0,"blurHeight":0};